import {Backup} from "./backup";

export class BackupMapper {

  public static map(data: any): Backup {
    const backup: Backup = new Backup();
    backup.id = data.id;
    backup.jobName = data.job_name;
    backup.date = data.updated_at ? new Date(parseInt(data.updated_at, 10) * 1000) : null;
    backup.file = data.file;
    backup.destination = data.destination;
    backup.folder = data.folder;
    backup.size = data.size;
    backup.jid = data.jid;
    backup.checkpoints = data.checkpoints;
    return backup;
  }

}
